import { useLanguage } from "../i18n/LanguageProvider";
import { LanguageToggle } from "../components/AppHeader";
import { Button } from "../components/primitives";
import { useAuth } from "../auth/AuthProvider";

export function LoginScreen() {
  const { t } = useLanguage();
  const { signIn } = useAuth();
  return (
    <main id="main-content" className="app-main" style={{ maxWidth: 420 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>{t("appName")}</h1>
        <LanguageToggle />
      </div>
      <p style={{ color: "var(--color-text-secondary)" }}>{t("dataPrivate")}</p>
      <Button variant="primary" onClick={signIn} style={{ width: "100%" }}>
        {t("signIn")}
      </Button>
    </main>
  );
}
